import * as types from "./types";

export function fetchAppLogsStart(clientUUID) {
  return {
    type: types.FETCH_APP_LOGS_START,
    clientUUID
  };
}

export function fetchAppLogsSuccess(logs) {
  return {
    type: types.FETCH_APP_LOGS_SUCCESS,
    logs
  };
}

export function fetchAppLogsFailure(data) {
  return {
    type: types.FETCH_APP_LOGS_FAILURE,
    data
  };
}

export function fetchCFRLogsURLStart(data, index) {
  return {
    type: types.FETCH_CFR_LOGS_URL_START,
    data,
    index
  };
}

export function fetchCFRLogsURLSuccess(index) {
  return {
    type: types.FETCH_CFR_LOGS_URL_SUCCESS,
    index
  };
}

export function fetchCFRLogsURLFailure(index) {
  return {
    type: types.FETCH_CFR_LOGS_URL_FAILURE,
    index
  };
}
